import { useState } from 'react';
import { useLanguage } from '../LanguageContext';
import ButtonIcon from './ButtonIcon';
import { IconSend } from './icons/ActionIcons';

export default function ContactForm() {
  const { t } = useLanguage();
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');

  function handleSubmit(e) {
    e.preventDefault();
    const to = t('contact.emailValue');
    const subject = encodeURIComponent(t('contactForm.mailSubject'));
    const lines = [
      t('contactForm.mailBodyIntro'),
      '',
      `${t('contactForm.nameLabel')}: ${name}`,
      `${t('contactForm.emailLabel')}: ${email}`,
      '',
      `${t('contactForm.messageLabel')}:`,
      message,
    ];
    const body = encodeURIComponent(lines.join('\n'));
    window.location.href = `mailto:${to}?subject=${subject}&body=${body}`;
  }

  return (
    <form className="contact-form" onSubmit={handleSubmit}>
      <h2 className="contact-form__title">{t('contactForm.formTitle')}</h2>

      <div className="contact-form__field">
        <label className="contact-form__label" htmlFor="contact-name">
          {t('contactForm.nameLabel')}
        </label>
        <input
          id="contact-name"
          className="contact-form__input"
          name="name"
          type="text"
          autoComplete="name"
          required
          value={name}
          onChange={(ev) => setName(ev.target.value)}
          placeholder={t('contactForm.namePlaceholder')}
        />
      </div>

      <div className="contact-form__field">
        <label className="contact-form__label" htmlFor="contact-email">
          {t('contactForm.emailLabel')}
        </label>
        <input
          id="contact-email"
          className="contact-form__input"
          name="email"
          type="email"
          autoComplete="email"
          required
          value={email}
          onChange={(ev) => setEmail(ev.target.value)}
          placeholder={t('contactForm.emailPlaceholder')}
        />
      </div>

      <div className="contact-form__field">
        <label className="contact-form__label" htmlFor="contact-message">
          {t('contactForm.messageLabel')}
        </label>
        <textarea
          id="contact-message"
          className="contact-form__textarea"
          name="message"
          rows={5}
          required
          value={message}
          onChange={(ev) => setMessage(ev.target.value)}
          placeholder={t('contactForm.messagePlaceholder')}
        />
      </div>

      <button type="submit" className="contact-form__submit btn-with-icon">
        <ButtonIcon icon={IconSend} size={18}>{t('contactForm.submit')}</ButtonIcon>
      </button>

      <p className="contact-form__helper">{t('contactForm.helper')}</p>
    </form>
  );
}
